<script lang="ts" setup>
import { useVModel } from "@vueuse/core"

type PeriodAbscence = {
    work: "before" | "after" | ""
    period: [Date, Date] | [null, null]
}

type Props = {
    modelValue: PeriodAbscence[]
    inputId: string
}

const props = withDefaults(defineProps<Props>(), {
    modelValue: () => [{ work: "", period: [null, null] }],
})

const emit = defineEmits(["update:modelValue"])

const innerValueModel = useVModel(props, "modelValue", emit, {
    eventName: "update:modelValue",
    deep: true,
    passive: true,
    defaultValue: [{ work: "", period: [null, null] }],
})

function onClickAddPeriode() {
    // Ajout d'une nouvelle période d'abscence
    innerValueModel.value.push({
        work: "",
        period: [null, null],
    })
}

function onClickRemovePeriode(index: number) {
    // Suppression d'une période d'abscence
    innerValueModel.value.splice(index, 1)
}
</script>
<template>
    <div class="input-abscence">
        <!-- Formulaire -->
        <div
            v-for="(period, index) in innerValueModel"
            :key="index"
            class="input-abscence__fieldset"
        >
            <legend class="flex items-center justify-between w-full">
                <p>Période d'abscence {{ index + 1 }}</p>
                <!-- Bouton ajouter -->
                <BaseButton
                    icon="pi pi-trash"
                    icon-pos="left"
                    rounded
                    text
                    severity="secondary"
                    @click="onClickRemovePeriode(index)"
                />
            </legend>
            <BaseCheckboxList
                :options="[
                    { label: 'Avant les travaux', value: 'before' },
                    { label: 'Après les travaux', value: 'after' },
                ]"
                :input-id="`${props.inputId}-${index}-select-period`"
                :name="`${props.inputId}-${index}-select-period`"
                option-label="label"
                option-value="value"
                v-model="period.work"
                radio
                horizontal
            />
            <div class="flex gap-4 w-full">
                <BaseInputWrapper
                    class="w-full"
                    label="Date de début"
                    input-id="start_date"
                >
                    <BaseDatePicker
                        id="start_date"
                        v-model="period.period[0]"
                        placeholder="--/--/--"
                        date-format="dd/mm/yy"
                        :max-date="new Date()"
                    />
                </BaseInputWrapper>
                <BaseInputWrapper
                    class="w-full"
                    label="Date de fin"
                    input-id="end_date"
                >
                    <BaseDatePicker
                        id="end_date"
                        v-model="period.period[1]"
                        placeholder="--/--/--"
                        date-format="dd/mm/yy"
                        :max-date="new Date()"
                    />
                </BaseInputWrapper>
            </div>
        </div>

        <!-- Bouton ajouter -->
        <BaseButton
            class="w-fit"
            icon="pi pi-plus"
            icon-pos="left"
            severity="secondary"
            @click="onClickAddPeriode"
            label="Nouvelle période"
        />
    </div>
</template>

<style scoped>
.input-abscence {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    .input-abscence__fieldset {
        display: flex;
        flex-direction: column;
        gap: 1rem;

        padding: 0.5rem 0.5rem 0.5rem 1rem;
        border-left: 1px solid var(--p-primary-400);

        legend {
            color: var(--p-primary-400);

            color: #1d6ee7;

            font-size: 0.875rem;
            font-weight: 600;
            line-height: 1.5rem; /* 171.429% */
        }
    }
}
</style>
